import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import * as React from "react";

interface LoaderProps {
  style?: React.CSSProperties;
  className?: string;
  loadingText?: string;
}

export const CanvasLoader = ({ style, className, loadingText }: LoaderProps) => {
  const wrapperRef = React.useRef<HTMLDivElement>();

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).Loader.init(wrapperRef.current);
  }, []);
  React.useEffect(() => {
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).Loader.stop();
    };
  }, []);
  return (
    <Row align="middle" justify="center" style={style} className={className}>
      <Col
        className="text-center"
        ref={wrapperRef}
        style={loadingText !== undefined ? { display: "flex", flexDirection: "column-reverse" } : null}
      >
        <h3>{loadingText}</h3>
      </Col>
    </Row>
  );
};

const Loader: React.FC<LoaderProps> = ({ style, className }) => (
  <Row align="middle" justify="center" style={style} className={className}>
    <Col className="text-center">
      <FontAwesomeIcon className="loader" icon={["fal", "circle-notch"]} size="3x" spin={true} />
    </Col>
  </Row>
);

const LoaderSuccess: React.FC<LoaderProps> = ({ style }) => (
  <Row align="middle" justify="center" style={style}>
    <Col className="text-center" span={24}>
      <FontAwesomeIcon className="text-success" icon={["fal", "check-circle"]} size="3x" />
    </Col>
    <Col span={24} className="text-center">
      <h3>SUCCESS</h3>
    </Col>
  </Row>
);

const LoaderError: React.FC<LoaderProps> = ({ style }) => (
  <Row align="middle" justify="center" style={style}>
    <Col className="text-center" span={24}>
      <FontAwesomeIcon icon={["fal", "ambulance"]} size="3x" />
    </Col>
  </Row>
);

const LoaderReject: React.FC<LoaderProps> = ({ style }) => (
  <Row align="middle" justify="center" style={style}>
    <Col className="text-center" span={24}>
      <FontAwesomeIcon icon={["far", "ban"]} size="3x" />
    </Col>
  </Row>
);

Loader.displayName = "Loader";

export { Loader, LoaderSuccess, LoaderError, LoaderReject };
